import { IBookingSlot } from "./bookingSlots";
import { IMember } from "./member";

export class IBooking {
    _id: string;
    bookingnumber:string;
    name: string;
    status: string;
    isDelete: boolean;
    company: string;
    branch: string;
    comment: string;
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
    customer: IMember;
    BookingSlot: IBookingSlot;
}
